import { createFileRoute, redirect } from '@tanstack/react-router';
import { guardRoute } from '@/lib/route-guards';

/** `/me/payslips` (FR-PAY-18, US-P7): a deep link to the Payslips tab of my profile. */
export const Route = createFileRoute('/_app/me_/payslips')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/me');
    throw redirect({ to: '/me', search: { tab: 'payslips' }, replace: true });
  },
});
